module.exports = __webpack_public_path__ + "img/crusher.31cc30bf.png";